import { FormControl, MenuItem, Select } from "@material-ui/core"
import PropTypes from "prop-types"
import useStyles from "./styles"

const VaasLocationFilter = ({
  vaasLocation,
  handleChangeVaasLocation,
  options,
}) => {
  const classes = useStyles()

  return (
    <FormControl variant="outlined" className={classes.selectContainer}>
      <Select value={vaasLocation} onChange={handleChangeVaasLocation}>
        <MenuItem value={"all"}>All Locations</MenuItem>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

VaasLocationFilter.propTypes = {
  vaasLocation: PropTypes.string,
  handleChangeVaasLocation: PropTypes.func,
}
export default VaasLocationFilter
